import { useEffect, useState } from "react";
import api from "../../../api/api";
import { Link, useNavigate } from "react-router-dom";
import { FiUserPlus } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import CourseCard from "../../../components/Course/CourseCard";
import { useProfileStore } from "../../../store/useUserStore";
import TabHeader from "../../../components/Header/TabHeader";
import { motion, AnimatePresence } from "framer-motion";

let initialCourse: any = [];

const School = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    courses,
    setCourses,
    selectedStudent,
    setSelectedStudent,
    students,
    setLoading,
    homePageShow,
    setShowGuidanceFlow,
    setGuidanceStep,
  } = useProfileStore((state: any) => state);

  useEffect(() => {
    if (selectedStudent) {
      getCourses(selectedStudent.id);
    }
  }, [selectedStudent]);

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (searchTerm == "") {
      setCourses(initialCourse);
    }
  }, [searchTerm, selectedStudent]);

  function search() {
    if (searchTerm == "") return;
    console.log("search", searchTerm);
    setLoading(true);
    api
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/parent/home/search?mode=school&student_id=${selectedStudent.id}&query=${searchTerm}`,
      )
      .then((res) => {
        console.log("res", res);
        if (res.data.data.is_external === false) {
          // stay in School tab
          console.log(res.data.data.courses);
          setCourses(res.data.data.courses);
        } else if (res.data.data.is_external === true) {
          // navigate to Academy tab
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function getCourses(studentId: number) {
    setLoading(true);
    api
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/parent/home/search?mode=school&student_id=${studentId}`,
      )
      .then((res) => {
        console.log("res courses", res.data.data.courses);

        let concatDay = "";
        let concatTime = "";
        for (let course of res.data.data.courses) {
          let days: string[] = [];
          let startTimes: string[] = [];

          // for (let sch of course.schedules) {
          //     days.push(sch.day.label);
          //     startTimes.push(formatTime(sch.start_time));
          // }

          concatDay =
            days.length > 2
              ? `${days.slice(0, 2).join(", ")} ...`
              : days.join(", ");
          concatTime =
            startTimes.length > 2
              ? `${startTimes.slice(0, 2).join(", ")} ...`
              : startTimes.join(", ");

          course["concatDay"] = concatDay;
          course["concatTime"] = concatTime;
        }

        setCourses(res.data.data.courses);
        initialCourse = res.data.data.courses;
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleSelectStudent(studentObj: any) {
    // console.log("handleSelectStudnet", studentObj.id, JSON.stringify(studentObj))
    localStorage.setItem("selectedStudent", JSON.stringify(studentObj));
    setSearchTerm("");
    setSelectedStudent(studentObj);
    getCourses(studentObj.id);
    setIsOpen(false);
  }

  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleClickOutside = (event: any) => {
    // Close the dropdown if clicked outside
    if (!event.target.closest(".dropdown-container")) {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    if (homePageShow && homePageShow === "academy") {
      return navigate("/academy");
    } else if (homePageShow && homePageShow === "explore") {
      return navigate("/");
    }
    // Attach event listener to close dropdown on outside click
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const processedCourses = courses.map((course: any) => {
    const allDaysSet = new Set<string>();

    course.time_slots?.forEach((timeslot: any) => {
      allDaysSet.add(timeslot.day); // e.g., "Monday"
    });

    const dayOrder = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];

    const dayShortMap: { [key: string]: string } = {
      Monday: "Mon",
      Tuesday: "Tues",
      Wednesday: "Wed",
      Thursday: "Thur",
      Friday: "Fri",
      Saturday: "Sat",
      Sunday: "Sun",
    };

    const sortedDays = dayOrder
      .filter((day) => allDaysSet.has(day))
      .map((day) => dayShortMap[day]);

    return {
      ...course,
      concatDayArray: sortedDays,
    };
  });

  return (
    <>
      <TabHeader defaultTab="school" />
      <div className="mt-4">
        <div className="mb-6 grid grid-cols-2 gap-2 px-0">
          {/* Student Dropdown */}
          <div className="relative dropdown-container">
            <button
              className="text-lg font-light rounded-3xl px-2 py-1 bg-white shadow-course-card flex items-center w-full gap-2"
              onClick={toggleDropdown}
            >
              <img
                className="h-6 w-6 rounded-3xl mr-2"
                alt=""
                src={
                  selectedStudent?.profile_pic ||
                  "/assets/img/default-profile.jpg"
                }
              />
              <span className="truncate w-40 overflow-hidden text-ellipsis text-start whitespace-nowrap">
                {selectedStudent?.name || t("home.no_student_selected")}
              </span>
            </button>

            {isOpen && (
              <div
                className="absolute mt-2 bg-white shadow-course-card rounded-lg w-full z-20"
                style={{ maxHeight: "20rem", overflowY: "auto" }}
              >
                {students.map((student: any) => (
                  <div
                    key={student.id}
                    className="flex items-center px-2 md:px-4 py-2 hover:bg-gray-100 cursor-pointer "
                    onClick={() => handleSelectStudent(student)}
                  >
                    <img
                      className="h-10 w-10 rounded-lg mr-2"
                      alt=""
                      src={
                        student?.profile_pic ||
                        "/assets/img/default-profile.jpg"
                      }
                    />
                    <span className="truncate">{student.name}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Search Input */}
          <div className="flex items-center w-full ">
            <input
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-[95%] sm:w-full bg-gray-200 placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-l-xl pl-2 py-1 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 focus:shadow"
              placeholder={t("home.search")}
            />
            <button
              onClick={() => {
                search();
              }}
              className="p-2 bg-theme flex justify-center items-center rounded-r-xl"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#FFF"
                className="w-4 h-4"
              >
                <path
                  fillRule="evenodd"
                  d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Course Grid */}
        {students.length > 0 ? (
          <div>
            {processedCourses.length > 0 ? (
              <div className="grid grid-cols-2 gap-2">
                {processedCourses.map((course: any, index: number) => (
                  <div key={index}>
                    <CourseCard
                      explore={false}
                      course_id={course.course_branch_id}
                      name={course.course_name}
                      concatDayArray={course.concatDayArray}
                      images={course.images}
                      pricing_packages={course.pricing_packages}
                      schedule={course.time_slots}
                      promotions_tag={course.promotions_tag}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex items-center justify-center h-[60vh] text-center">
                <div className="text-lg font-semibold">
                  {t("home.no_course_found")}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="text-center pt-16 flex justify-center items-center">
            <div>
              <h5>{t("home.please_add_child_first")}</h5>
              <div className="flex justify-center">
                <button
                  onClick={() => {
                    navigate(`/children/add`);
                  }}
                  type="button"
                  className="mt-3 gap-3 text-white text-[16px] leading-none w-full py-[13px] bg-theme border-none rounded-3xl flex items-center justify-center"
                >
                  <FiUserPlus /> {t("home.go_to_profile")}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default School;
